import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
export default {
argroup() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/arinv/postgroupkoran");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
bankaccount() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/bankcashacc/allaccount");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
list(obj = {}) {
    return new Promise(async (resolve, reject) => {
        try {
            const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];
            let str = '';
            for (const key in obj) {
                if (keys.indexOf(key) >= 0 && obj[key]) {
                    str += str ? '&' : '?';
                    str += key + '=' + encodeURIComponent(obj[key]);
                }
            }
            const url = `/arkoranpaym${str}`;
            const { data } = await axios.get(url);
            const { meta, list } = data;
            obj.total = meta.total;
            resolve(list);
        } catch (error) {
            errorHandler(error, reject);
        }
    });
},
currency() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/currency/cbo");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
arpaymdetail(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get(`arkoranpaym/arpaymdetail/${obj.arpaymKey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
insert(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            await axios.post("arkoranpaym", obj);
            resolve();
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
remove(obj) {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.delete(`arkoranpaym/${obj.arpaymKey}`);
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
potongan() {
    return new Promise(async (resolve, reject) => {
        try {
            const {
                data
            } = await axios.get("/arkoranpaym/potongan");
            resolve(data);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
printjv(obj = {}) {
    return new Promise(async (resolve, reject) => {
        let url;
        let str = '';
        try {
            str = '?key=' + encodeURIComponent(obj.arpaymKey);
            url = `/arkoranpaym/printjv`;

            url += str;
            const { data } = await axios.get(url);
            const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
            resolve(link);
        } catch (error) {
            errorHandler(error, reject)
        }
    });
},
exportXls(obj = {}) {
    const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'namabank', 'reference', 'tgldue1', 'tgldue2'];

    let str = '';
    for (const key in obj) {
        if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? '&' : '?';
            str += key + '=' + encodeURIComponent(obj[key]);
        }
    }

    axios({
        url: `/arkoranpaym/exportxls${str}`,
        method: 'GET',
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'arkoranpaym.xlsx');
        document.body.appendChild(link);
        link.click();
        // window.location.assign(url);
    });
}

};